import { BottomSheet } from '@shared/ui/containers/BottomSheet';
import { QuickLinkTile, type QuickLinkItem } from '@features/dashboard/QuickLinkTile';

interface QuickLinksSheetProps {
  /** Every quick link, already in most-recently-used order. */
  links: QuickLinkItem[];
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSelect: (link: QuickLinkItem) => void;
}

/**
 * Swipe-up sheet listing every quick link — the home rail only carries the
 * first `QUICK_LINKS_VISIBLE` of them.
 */
export function QuickLinksSheet({
  links,
  open,
  onOpenChange,
  onSelect,
}: QuickLinksSheetProps): JSX.Element {
  return (
    <BottomSheet
      open={open}
      onOpenChange={onOpenChange}
      title="Quick Links"
      height="min(72dvh, 560px)"
    >
      <ul className="grid grid-cols-4 gap-3 pb-2">
        {links.map((link) => (
          <li key={link.id}>
            <QuickLinkTile link={link} onSelect={() => onSelect(link)} />
          </li>
        ))}
      </ul>
    </BottomSheet>
  );
}
